<template>
  <div class="footer">
    <div class="footer-container">
      <router-link to="/">
        <img src="../assets/img/logo.jpg" />
      </router-link>
      <div class="footer-section">
        <div class="footer-addr">
          04617 서울시 중구 동호로 24길 27-17, 우리함께빌딩 3층 / Tel.
          010-3270-0548(02-725-1994)
        </div>
        <div class="footer-sponsor">
          후원계좌 : KEB하나은행 162-910019-54204 / 신대승네트워크
        </div>
        <div class="footer-copyright">
          Copyleft © newbuddha.org. Free sharing of copyright.
        </div>
      </div>
    </div>

    <div class="ph-footer-container">
      <router-link to="/">
        <img src="../assets/img/logo.jpg" />
      </router-link>
      <div class="footer-section">
        <div class="footer-addr">
          04617 서울시 중구 동호로 24길 27-17,<br />
          우리함께빌딩 3층 <br />
          Tel. 010-3270-0548(02-725-1994)
        </div>
        <div class="footer-sponsor">
          후원계좌 : KEB하나은행 162-910019-54204 <br />
          신대승네트워크
        </div>
        <div class="footer-copyright">
          Copyleft © newbuddha.org. <br />
          Free sharing of copyright.
        </div>
      </div>
    </div>
  </div>
</template>

<style>
@import "../assets/css/footer.css";
</style>
